import { Input } from '@common/components/Input'
import { ButtonContainer } from '@common/components/ButtonContainer'
import { Button } from '@common/components/Button'
import { useState } from 'react'
import {
  Dialog,
  DialogContainer,
  DialogHeader,
  DialogSubtitle,
  DialogTopTitle,
} from './Dialog.styles'

export const CaptureNameDialog = ({
  defaultValue,
  onNext,
}: {
  defaultValue: string
  onNext: (name: string) => void
}) => {
  const [name, setName] = useState(defaultValue)

  return (
    <DialogContainer
      onSubmit={(e) => {
        e.preventDefault()
        onNext(name)
      }}
    >
      <Dialog>
        <DialogTopTitle>Steg 1 av 3</DialogTopTitle>
        <DialogHeader>Vad heter föreningen?</DialogHeader>
        <DialogSubtitle>Du kan alltid ändra namnet senare.</DialogSubtitle>
        <div style={{ marginTop: '1rem' }} />
        <Input value={name} placeholder="Brf Booet" autoFocus onChange={(e) => setName(e.currentTarget.value)} />
        <div style={{ marginTop: '1rem' }} />
        <ButtonContainer>
          <Button type="submit" disabled={!name}>
            Nästa
          </Button>
        </ButtonContainer>
      </Dialog>
    </DialogContainer>
  )
}
